var _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgRollingLoad = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 200,
  height: 200,
  className: "rolling-load_svg__lds-rolling",
  preserveAspectRatio: "xMidYMid",
  style: {
    backgroundImage: "none",
    backgroundPosition: "initial initial",
    backgroundRepeat: "initial initial"
  },
  viewBox: "0 0 100 100"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 50,
  r: 35,
  fill: "none",
  stroke: "#555",
  strokeDasharray: "164.93361431346415 56.97787143782138",
  strokeWidth: 10
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  begin: "0s",
  calcMode: "linear",
  dur: "1s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "rotate",
  values: "0 50 50;360 50 50"
}))));
export default SvgRollingLoad;